import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { reactSelectStyles, reactSelectComponents } from 'src/features/_shared/styles/react-select.styles';
import { Bar } from 'react-chartjs-2';
import {
    CustomerExerciseFilter,
    filterTrainedExerciseGroup,
    filterTrainedExerciseName,
    filterTrainedExerciseTimeframe,
    resetExerciseProgresses,
    selectParameter,
    setDashboardExercise,
    setDashboardExerciseSummary,
    setExerciseProgresses,
    setExerciseSets,
    setTrainedExercisesItems,
    setTrainedGroupItems,
} from '../state/customer.analysis.slice';
import moment from 'moment';
import { DashboardManager } from 'src/_shared/managers/dashboard.manager';
import {
    DashboardExerciseProgress,
    DashboardExerciseProgressRequest,
    DashboardExerciseProgressRequestTimeframeEnum,
    DashboardExerciseResponse,
    DashboardTimeframedRequest,
    MostTrainedExercise,
    ProgramSessionSet,
    ProgramSessionSetSearchRequest,
    User,
} from 'src/api/entities';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { SelectableExerciseGroup } from 'src/features/exercise/utils/muscleGroups';
import { SelectableExercise } from '../state/customer.slice';
import { Button } from 'src/features/_shared/components/Button/button.component';
import { WorkoutSessionSetManager } from 'src/_shared/managers/workout.session.set.manager';
import { SelectableTimeframe } from 'src/features/exercise/utils/timeframes';
import { FormManager } from 'src/_shared/managers/form.manager';
import { SelectableParameter, selectableParameters } from 'src/features/exercise/utils/selectableParameters';
import { PageTransition } from 'src/features/_shared/components/PageTransition/page.transition.component';
import { EmptyState } from 'src/features/_shared/components/EmptyState/empty.state.component';

export const CustomerAnalysisView: React.FC = () => {
    const dashboardManager = DashboardManager.getInstance();
    const workoutSessionSetManager = WorkoutSessionSetManager.getInstance();

    const customer: User = useStoreSelector(state => state.reducer.customerSlice.customer);
    const customerExerciseFilters: CustomerExerciseFilter = useStoreSelector(state => state.reducer.customerAnalysisSlice.trainedExerciseFilters);
    const trainedExercises: MostTrainedExercise[] = useStoreSelector(state => state.reducer.customerAnalysisSlice.trainedExercises);
    const trainedGroups: SelectableExerciseGroup[] = useStoreSelector(state => state.reducer.customerAnalysisSlice.trainedGroups);
    const selectableExercises: SelectableExercise[] = useStoreSelector(state => state.reducer.customerAnalysisSlice.selectableExercises);
    const dashboardExerciseResponse: DashboardExerciseResponse = useStoreSelector(state => state.reducer.customerAnalysisSlice.dashboardExerciseResponse);
    const exerciseSets = useStoreSelector(state => state.reducer.customerAnalysisSlice.exerciseSets);
    const exerciseProgresses = useStoreSelector(state => state.reducer.customerAnalysisSlice.exerciseProgresses);

    const getItems = async () => {
        const request: DashboardTimeframedRequest = {
            authorID: customer.id,
        };
        const value = await dashboardManager.getAllTrainedExercise(request);
        store.dispatch(setTrainedExercisesItems({ value }));
        console.log(value);

        const groups = await dashboardManager.getAllTrainedGroups(request);
        store.dispatch(setTrainedGroupItems({ groups }));
        console.log(value);
    };

    useEffect(() => {
        getItems();
        console.log(trainedExercises);
    }, []);

    const searchExerciseSets = async (exerciseUuid: string) => {
        const request: ProgramSessionSetSearchRequest = {
            filter: {
                authorID: customer.id,
            },
        };
        const value = await workoutSessionSetManager.searchByExerciseUuid(request, exerciseUuid);
        store.dispatch(setExerciseSets({ value }));
    };

    const getDashboardExerciseProgress = async (exerciseUuid: string, timeframe: DashboardExerciseProgressRequestTimeframeEnum) => {
        store.dispatch(resetExerciseProgresses());
        const request: DashboardExerciseProgressRequest = {
            authorID: customer.id!,
            exerciseUuid: exerciseUuid,
            timeframe: timeframe,
            year: 2025,
        };
        const value = await dashboardManager.getDashboardExerciseProgress(request);
        store.dispatch(setExerciseProgresses({ value }));
    };

    const getDashboardExercise = async (exerciseUuid: string, timeframe: DashboardExerciseProgressRequestTimeframeEnum) => {
        const request: DashboardExerciseProgressRequest = {
            authorID: customer.id,
            exerciseUuid: exerciseUuid,
            timeframe: timeframe,
            year: moment().year(),
        };
        const value = await dashboardManager.getDashboardExercise(request);
        store.dispatch(setDashboardExercise({ value }));
    };

    const handleFilterGroup = async (selectedGroup: SelectableExerciseGroup) => {
        console.log('value', selectedGroup);
        setExerciseFilterValuesState({ name: exerciseFilterValuesState.name, group: selectedGroup.value });
        store.dispatch(filterTrainedExerciseGroup({ selectedGroup }));
    };

    const handleFilterName = async (selectedName: SelectableExercise) => {
        console.log('value', selectedName);
        console.log(trainedExercises);
        const value: MostTrainedExercise = trainedExercises.find(trained => trained.exerciseUuid == selectedName.value)!;
        console.log(value);
        if (value != undefined) {
            store.dispatch(filterTrainedExerciseName({ value }));
            console.log(customerExerciseFilters.name!.exerciseUuid!);
            console.log(selectedName.value!);
            await getDashboardExercise(selectedName.value, customerExerciseFilters.timeframe!);
            await searchExerciseSets(selectedName.value);
            await getDashboardExerciseProgress(selectedName.value, customerExerciseFilters.timeframe!);
        }
    };

    const handleClear = async () => {
        resetExerciseProgresses(); 
        // resetField('queryName');
        // setExerciseFilterValuesState(initialExerciseFilterValuesState);
        // store.dispatch(resetFilters());
        // const value = await exerciseManager.search(user.id!);
        // store.dispatch(setItems({ value }));
    };

    const [exerciseFilterValuesState, setExerciseFilterValuesState] = useState<CustomerExerciseFilter>({
        name: {},
        group: '',
        timeframe: DashboardExerciseProgressRequestTimeframeEnum.Year,
    });
    const [selectedTimeframe, setSelectedTimeframe] = useState<SelectableTimeframe>({ value: 'YEAR', label: 'Year' });

    const handleSelectTimeframe = async (selectedTF: SelectableTimeframe) => {
        setSelectedTimeframe(selectedTF);
        let selectedTFM: DashboardExerciseProgressRequestTimeframeEnum;

        switch (selectedTF.value) {
            case 'SIX_MONTHS':
                selectedTFM = DashboardExerciseProgressRequestTimeframeEnum.SixMonths;
                break;
            case 'YEAR':
                selectedTFM = DashboardExerciseProgressRequestTimeframeEnum.Year;
                break;
            case 'LIFETIME':
                selectedTFM = DashboardExerciseProgressRequestTimeframeEnum.Lifetime;
                break;
            default:
                selectedTFM = DashboardExerciseProgressRequestTimeframeEnum.Year;
        }

        store.dispatch(filterTrainedExerciseTimeframe({ selectedTFM }));

        await Promise.resolve().then(async () => {
            console.log('redux state', customerExerciseFilters);
            console.log(selectedTFM)

            if (customerExerciseFilters.name && customerExerciseFilters.name.exerciseUuid) {
                await getDashboardExercise(customerExerciseFilters.name!.exerciseUuid!, selectedTFM);
                await getDashboardExerciseProgress(customerExerciseFilters.name!.exerciseUuid!, selectedTFM);
            }
        });
    };

    const handleSelectParameter = async (value: SelectableParameter) => {
        store.dispatch(selectParameter({ value }));
    };

    const monthNames = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

    const labels = exerciseProgresses && exerciseProgresses.map(progress => monthNames[Number(progress.month) - 1]);

    const timeframes: SelectableTimeframe[] = [
        { value: DashboardExerciseProgressRequestTimeframeEnum.SixMonths, label: 'Six months' },
        { value: DashboardExerciseProgressRequestTimeframeEnum.Year, label: 'Year' },
        { value: DashboardExerciseProgressRequestTimeframeEnum.Lifetime, label: 'Lifetime' },
    ];

    const selectedProgressParameter = (progress: DashboardExerciseProgress) => {
        switch (customerExerciseFilters.selectedParameter?.value) {
            case 'WEIGHT':
                return progress.averageWeight;
            case 'REPS':
                return progress.averageReps;
            case 'MAX_WGT':
                return progress.maxWeight;
            case 'MIN_WGT':
                return progress.minWeight;
            case 'MAX_REPS':
                return progress.maxReps;
            case 'AVG_REPS':
                return progress.minReps;
            case 'MIN_REPS':
                return progress.minReps;
            case 'TONS':
                return progress.ton;
            case 'SETS':
                return progress.volume;
            case '1RM':
                return progress.oneRm;
            default:
                return progress.averageWeight;
        }
    };

    const data = {
        labels,
        datasets: [
            {
                label: '',
                data: exerciseProgresses && exerciseProgresses.map(progress => Number(selectedProgressParameter(progress))),
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                text: 'Chart.js Bar Chart',
            },
        },
    };

    const statCards: { label: string; value: any }[] = [
        { label: 'Frequency', value: dashboardExerciseResponse.summary?.frequency },
        { label: 'MAX reps', value: dashboardExerciseResponse.summary?.maxReps },
        { label: 'AVG reps', value: dashboardExerciseResponse.summary?.averageReps },
        { label: 'MIN reps', value: dashboardExerciseResponse.summary?.minReps },
        { label: 'MAX weight', value: dashboardExerciseResponse.summary?.maxWeight },
        { label: 'AVG weight', value: dashboardExerciseResponse.summary?.averageWeight },
        { label: 'MIN weight', value: dashboardExerciseResponse.summary?.minWeight },
        { label: '1RM', value: dashboardExerciseResponse.summary?.oneRm },
        { label: '95% 1RM', value: dashboardExerciseResponse.summary?.oneRm95 },
        { label: '90% 1RM', value: dashboardExerciseResponse.summary?.oneRm90 },
        { label: '85% 1RM', value: dashboardExerciseResponse.summary?.oneRm85 },
        { label: '80% 1RM', value: dashboardExerciseResponse.summary?.oneRm80 },
        { label: '75% 1RM', value: dashboardExerciseResponse.summary?.oneRm75 },
        { label: '70% 1RM', value: dashboardExerciseResponse.summary?.oneRm70 },
        { label: 'Tons', value: dashboardExerciseResponse.summary?.ton },
        { label: 'Volume', value: dashboardExerciseResponse.summary?.volume },
    ];

    return (
        <PageTransition className='mt-4 px-3 px-md-4'>
            {/* ── Page Header ──────────────────────────────────────────── */}
            <div
                className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 p-4 anim-slide-up'
                style={{
                    background: 'linear-gradient(135deg, #fff 0%, #fafafa 100%)',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                }}
            >
                <div>
                    <div className='d-flex align-items-center gap-2 mb-1'>
                        <i className='bi bi-bar-chart-line-fill' style={{ fontSize: '1.4rem', color: '#ff4949' }}></i>
                        <h4 className='mb-0 fw-bold' style={{ color: '#333' }}>Analisi</h4>
                    </div>
                    <p className='mb-0 mt-1' style={{ color: '#666', fontSize: '0.9rem' }}>
                        {customer.data?.details?.firstName && (
                            <>
                                <span className='fw-semibold' style={{ color: '#333' }}>
                                    {customer.data.details.firstName} {customer.data?.details?.lastName}
                                </span>
                                {' — '}
                            </>
                        )}
                        Dashboard esercizio e progressi
                    </p>
                </div>
                {customer.email && (
                    <div className='mt-2 mt-md-0'>
                        <span style={{ color: '#888', fontSize: '0.82rem' }}>
                            <i className='bi bi-envelope me-1' style={{ fontSize: '0.75rem' }}></i>
                            {customer.email}
                        </span>
                    </div>
                )}
            </div>

            {/* ── Filter Panel ─────────────────────────────────────────── */}
            <div
                className='p-4 mb-4 anim-slide-up'
                style={{
                    borderLeft: '3px solid #ff4949',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                    borderLeftWidth: 3,
                    borderLeftColor: '#ff4949',
                    background: '#fff',
                    position: 'relative',
                    zIndex: 10,
                }}
            >
                <div className='d-flex align-items-center gap-2 mb-3'>
                    <i className='bi bi-funnel-fill' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                    <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Filtri esercizio</h6>
                </div>

                <div className='row g-3 align-items-end'>
                    <div className='col-12 col-lg text-start'>
                        <label className='form-label text-muted small mb-1'>Gruppo</label>
                        <Select
                            styles={reactSelectStyles}
                            components={reactSelectComponents}
                            value={
                                exerciseFilterValuesState.group === '' || exerciseFilterValuesState.group === undefined
                                    ? null
                                    : trainedGroups.find(obj => obj.value === exerciseFilterValuesState.group)
                            }
                            options={trainedGroups}
                            onChange={(choice: SelectableExerciseGroup) => handleFilterGroup(choice)}
                        />
                    </div>

                    <div className='col-12 col-lg text-start'>
                        <label className='form-label text-muted small mb-1'>Esercizio</label>
                        <Select
                            styles={reactSelectStyles}
                            components={reactSelectComponents}
                            value={
                                exerciseFilterValuesState.name?.exerciseName === '' || exerciseFilterValuesState.name === undefined
                                    ? null
                                    : trainedExercises.find(obj => obj.exerciseName === exerciseFilterValuesState.name)
                            }                            options={selectableExercises ?? []}
                            onChange={(choice: SelectableExercise) => handleFilterName(choice)}
                        />
                    </div>

                    <div className='col-12 col-lg text-start'>
                        <label className='form-label text-muted small mb-1'>Periodo</label>
                        <Select
                            styles={reactSelectStyles}
                            components={reactSelectComponents}
                            value={timeframes.find(tf => tf.value === selectedTimeframe.value)}
                            options={timeframes ?? []}
                            onChange={async (choice: SelectableTimeframe) => {
                                await handleSelectTimeframe(choice);
                            }}
                        />
                    </div>

                    <div className='col-12 col-lg text-start'>
                        <label className='form-label text-muted small mb-1'>Parametro</label>
                        <Select
                            styles={reactSelectStyles}
                            components={reactSelectComponents}
                            value={selectableParameters.find(sp => sp.value === customerExerciseFilters.selectedParameter?.value)}
                            options={selectableParameters ?? []}
                            onChange={async (choice: SelectableParameter) => {
                                await handleSelectParameter(choice);
                            }}
                        />
                    </div>

                    <div className='col-12 col-lg-auto'>
                        <Button
                            identifier='Pulisci'
                            icon={<i className='bi bi-x-circle' style={{ fontSize: '0.9rem' }}></i>}
                            onClick={handleClear}
                            variant='secondary'
                        />
                    </div>
                </div>
            </div>

            {/* ── Stat Cards ───────────────────────────────────────────── */}
            <div className='mb-4'>
                <div className='d-flex align-items-center gap-2 mb-3'>
                    <i className='bi bi-grid-3x3-gap-fill' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                    <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Riepilogo</h6>
                </div>
                <div className='row g-3 anim-stagger-grid'>
                    {statCards.map((card, index) => (
                        <div key={card.label} className='col-6 col-sm-4 col-md-3 col-lg-2'>
                            <div
                                className='app-card d-flex flex-column align-items-center justify-content-center p-3'
                                style={{ minHeight: 100 }}
                            >
                                <h4 style={{ color: '#D93955' }} className='fw-bold fs-4 mb-1'>
                                    {card.value ?? '—'}
                                </h4>
                                <span style={{ fontSize: '0.78rem', fontWeight: 400, color: '#888', textAlign: 'center' }}>
                                    {card.label}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Chart ────────────────────────────────────────────────── */}
            {exerciseProgresses && exerciseProgresses.length > 0 && (
                <div
                    className='mb-4 p-4 anim-fade-in'
                    style={{
                        background: '#fff',
                        borderRadius: 12,
                        border: '1px solid rgba(0,0,0,0.06)',
                    }}
                >
                    <div className='d-flex align-items-center gap-2 mb-3'>
                        <i className='bi bi-graph-up' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                        <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Progressi</h6>
                    </div>
                    <Bar options={options} data={data} />
                </div>
            )}

            {/* ── Exercise History ─────────────────────────────────────── */}
            {exerciseSets && exerciseSets.length > 0 ? (
                <div className='mb-4'>
                    <div className='d-flex align-items-center gap-2 mb-3'>
                        <i className='bi bi-clock-history' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                        <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Storico esercizio</h6>
                        <span className='badge rounded-pill ms-1' style={{ backgroundColor: '#f2f2f2', color: '#666', fontSize: '0.72rem' }}>
                            {exerciseSets.length} record
                        </span>
                    </div>
                    <div className='d-flex flex-column gap-2'>
                        {[...exerciseSets]
                            .sort((a, b) => new Date(b.setDate!).getTime() - new Date(a.setDate!).getTime())
                            .map((workoutSessionSet: ProgramSessionSet, index: number) => (
                                <div
                                    className='app-card anim-stagger'
                                    key={workoutSessionSet.id || index}
                                    style={{
                                        '--anim-index': index,
                                        borderLeft: '3px solid #ff4949',
                                        padding: 0,
                                        overflow: 'hidden',
                                    } as React.CSSProperties}
                                >
                                    <div className='d-flex flex-column flex-sm-row justify-content-between align-items-sm-center p-3 gap-2'>
                                        <div className='d-flex align-items-center gap-3'>
                                            <div
                                                style={{
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#fef2f2',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <i className='bi bi-activity' style={{ fontSize: '0.9rem', color: '#ff4949' }}></i>
                                            </div>
                                            <div>
                                                <h6 className='mb-0 fw-semibold' style={{ fontSize: '0.9rem', color: '#222' }}>
                                                    {workoutSessionSet.sessionName}
                                                </h6>
                                                <span style={{ fontSize: '0.78rem', color: '#aaa' }}>
                                                    <i className='bi bi-calendar3 me-1' style={{ fontSize: '0.7rem' }}></i>
                                                    {moment(workoutSessionSet.setDate).format('D MMMM YYYY')}
                                                </span>
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center gap-2 ms-sm-0 ms-5'>
                                            <span
                                                className='badge rounded-pill'
                                                style={{
                                                    backgroundColor: '#fff0f0',
                                                    color: '#ff4949',
                                                    fontSize: '0.85rem',
                                                    fontWeight: 700,
                                                    padding: '0.4em 0.9em',
                                                }}
                                            >
                                                {workoutSessionSet.weight} kg
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            ) : (
                exerciseSets && exerciseSets.length === 0 && (
                    <EmptyState
                        icon='bi bi-bar-chart-line'
                        title='Nessun dato'
                        description='Seleziona un esercizio dal filtro per visualizzare i dati di allenamento.'
                    />
                )
            )}
        </PageTransition>
    );
};